import { render, staticRenderFns } from "./OCRList.vue?vue&type=template&id=5cec3646&"
import script from "./OCRList.vue?vue&type=script&lang=js&"
export * from "./OCRList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./OCRList.vue?vue&type=custom&index=0&blockType=i18nf"
if (typeof block0 === 'function') block0(component)

export default component.exports